enum WorkspaceProjectType {
  reforestation = '',
  'renewable_energy_solar' = 'Renewable (Solar)',
  redd = 'Reduced Emissions from Deforestation and Degradation (REDD)',
  construction = 'Construction',
  'agricultural_land_management' = 'Agricultural Land Management',
  'waste_handling_and_disposal' = 'Waste handling and disposal',
  'manufacturing_industries' = 'Manufacturing industries',
}

export default WorkspaceProjectType
